export const STEPS = {
  INIT: 0,
  DRAW_FIELD_RECTANGLE: 1,
  SELECT_MAST_ARRANGEMENT: 2,
  DRAW_MASTS_RECTANGLE: 3,
  EDIT_MAST_POINTS: 4,
  DRAW_BUILDINGS: 5,
  ENTER_PROJECT_DETAILS: 6,
  SUBMIT_PROJECT: 7,
};